import React from "react";
import { useSelector } from "react-redux";

import Routes from "./routes";
import Loader from "./components/_base/Loader";

function App() {
  const loader = useSelector((state) => state.loader);
  return (
    <>
      {loader.loading && <Loader />}
      <Routes />
    </>
  );
}

export default App;
